import { defineStore } from 'pinia';
import {
	type AllSocketMessages,
	type SocketListeners,
	type RegisteredSocketListeners,
	type SocketMessage,
} from '@/composables/socket';
import { type RecursivePartial } from '@/types/utils';

export const useSocketListenersStore = defineStore('socketListeners', {
	state: () => ({
		registeredListeners: {} as RegisteredSocketListeners,
	}),
	actions: {
		registerListeners(uuid: string, listeners: SocketListeners) {
			//there can be multiple listeners registered for the same event, so need to merge with existing listeners
			Object.keys(listeners).forEach((eventName) => {
				const registeredListeners =
					this.registeredListeners[eventName] || [];
				const listener = listeners[
					eventName as keyof SocketMessage
				] as (message: AllSocketMessages) => void | Promise<void>;

				registeredListeners.push({ uuid, cb: listener });
				this.registeredListeners[eventName] = registeredListeners;
			});
		},

		removeListeners(uuid: string) {
			this.registeredListeners = Object.fromEntries(
				Object.entries(this.registeredListeners).map(
					([key, listeners]) => [
						key,
						listeners.filter((l) => l.uuid !== uuid),
					]
				)
			) as RegisteredSocketListeners;
		},

		/**
		 * This methos should never be called by production code.
		 * It is only used for testing.
		 */
		emitEvent(payload: RecursivePartial<MessageEvent<unknown>>): void {
			if (payload.type) {
				const listeners = this.registeredListeners[payload.type];
				if (listeners) {
					for (const listener of listeners) {
						listener.cb(payload as AllSocketMessages);
					}
				}
			}
		},
	},
});
